// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__1ffII","spin":"styles_spin__3r3Hh"};